import React from 'react';
import { useIntl } from 'react-intl';
import styles from './index.styl';
import Icon from '../../../Icon';

const EmptyState = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.container}>
      <Icon name="card-search" width="60" height="60" />
      <div className={styles.title}>
        {formatMessage({ id: 'profile.payment.noSavedPaymentMethods' })}
      </div>
    </div>
  );
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfilePaymentMethods/EmptyState/index.jsx